module.exports = __webpack_public_path__ + "img/25-1.9564f131.png";